import z from "zod";
import dayjs from "dayjs";

export const ADDITIONAL_WORK_CATEGORIES = [
  "roof_work",
  "main_panel_upgrade",
  "tree_trimming",
  "energy_efficiency_kits",
  "ai_node_installation",
] as const;

export const AdditionalWorkCategorySchema = z.enum(ADDITIONAL_WORK_CATEGORIES);

export const AdditionalWorkSchema = z.object({
  category: AdditionalWorkCategorySchema,
  scheduledDate: z.string().nullable(),
  completedDate: z.string().nullable(),
  blocksInstallation: z.boolean(),
});

export type AdditionalWorkCategoryT = z.infer<typeof AdditionalWorkCategorySchema>;
export type AdditionalWorkT = z.infer<typeof AdditionalWorkSchema>;
export type AdditionalWorkStatusT = "completed" | "scheduled" | "not_scheduled";

export const ADDITIONAL_WORK_LABELS: Record<AdditionalWorkCategoryT, string> = {
  roof_work: "Roof Work",
  main_panel_upgrade: "Main Panel Upgrade",
  tree_trimming: "Tree Trimming",
  energy_efficiency_kits: "Energy Efficiency Kits",
  ai_node_installation: "AI Node Installation",
};

export const sortAdditionalWork = (items: AdditionalWorkT[]): AdditionalWorkT[] =>
  [...items].sort(
    (a, b) => ADDITIONAL_WORK_CATEGORIES.indexOf(a.category) - ADDITIONAL_WORK_CATEGORIES.indexOf(b.category),
  );

export const additionalWorkStatus = ({ scheduledDate, completedDate }: AdditionalWorkT): AdditionalWorkStatusT => {
  if (completedDate) return "completed";
  if (scheduledDate) return "scheduled";
  return "not_scheduled";
};

export const formatChipDate = (date: string): string => dayjs(date).format("MMM D");

export const formatFullDate = (date: string): string => dayjs(date).format("MMM D, YYYY");
